import app from '../_app';

const openSpecsExplanation = (popupId) => {
    const popup = document.querySelector(`.js-product-popup[data-popup="${popupId}"]`);

    if (!popup) {
        return;
    }

    app.lockBody();
    popup.setAttribute('data-open', '');
};

document.querySelectorAll('.js-specs-explanation-trigger').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openSpecsExplanation(trigger.dataset.popup);
    });
});
